import { IPaymentPayload } from 'utils/payment';

import { IEncryptCreditArgs } from './types';

export const encryptCredit = async (_args: IEncryptCreditArgs): Promise<IPaymentPayload> => {
  throw new Error('First data is not supported. This should never be called');
};

export { getStoredPrepaidCard, storePrepaidCard } from './store-prepaid-card';
